import React, { useRef } from 'react';
import Card from '../../components/Card/Card';
import { ExpansionPanel, ExpansionPanelContent, ExpansionPanelTrigger } from '@eventbrite/marmalade';
import type { FAQ } from './types';
import type { Section, SectionBuilder, SectionCardProps, SectionProps } from '../Section';
import { SectionTextView } from '../SectionTextView';
import { SectionCardView } from '../SectionCardView';

import styles from './FAQ.module.scss';

//@ts-ignore TS2739
export type FAQSectionProps = SectionProps<FAQ>;
export type FAQCardsProps = SectionCardProps<FAQ>;

export const FAQCard: React.FC<FAQCardsProps> = ({ data, onReadMoreClick }) => {
  const showReadMore = data.answer.length > 100;
  return (
    <SectionCardView
      title={data.question}
      body={data.answer}
      showReadMore={showReadMore}
      onReadMoreClick={onReadMoreClick}
    />
  );
};

export const FAQView: React.FC<FAQSectionProps> = ({ data }) => {
  return (
    <div id={data.question} className={styles.view__wrapper}>
      {/* @ts-ignore: TS2739 */}
      <ExpansionPanel>
        {/* @ts-ignore: TS2739 */}
        <ExpansionPanelTrigger className={styles.question}>{data.question}</ExpansionPanelTrigger>
        {/* @ts-ignore: TS2739 */}
        <ExpansionPanelContent className={styles.answer}>{data.answer}</ExpansionPanelContent>
      </ExpansionPanel>
    </div>
  );
};

export const FAQSingleView: React.FC<FAQSectionProps> = ({ data }) => {
  return <SectionTextView title={data.question} text={data.answer} />;
};

const FAQSection: SectionBuilder<FAQ> = (data) => ({
  key: data.question,
  CardView: ({ onReadMoreClick }) => <FAQCard data={data} onReadMoreClick={onReadMoreClick} />,
  GeneralView: () => <FAQView data={data} />,
  SingleView: () => <FAQSingleView data={data} />,
});

export default FAQSection;
